export default __webpack_public_path__ + "static/media/flag-albania.7bb3f228.svg";